"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEffectSubscription = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * Common effect subscription
 *
 * @param subscriber {() => Subscription} - RxJS subscriber
 */
function useEffectSubscription(subscriber) {
    react_1.default.useEffect(function () {
        var subscription = subscriber();
        return function cleanup() {
            subscription.unsubscribe();
        };
    }, []);
}
exports.useEffectSubscription = useEffectSubscription;
//# sourceMappingURL=use-effect-subscription.js.map